import { render, staticRenderFns } from "./starDisplay.vue?vue&type=template&id=23308fa6&"
import script from "./starDisplay.vue?vue&type=script&lang=js&"
export * from "./starDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23308fa6')) {
      api.createRecord('23308fa6', component.options)
    } else {
      api.reload('23308fa6', component.options)
    }
    module.hot.accept("./starDisplay.vue?vue&type=template&id=23308fa6&", function () {
      api.rerender('23308fa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2TJEiIG3Bw3ol/JS/comp/starDisplay.vue"
export default component.exports